import { render, staticRenderFns } from "./addOrEdit.vue?vue&type=template&id=0bf9d6dc&scoped=true"
import script from "./addOrEdit.vue?vue&type=script&lang=js"
export * from "./addOrEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf9d6dc",
  null
  
)

export default component.exports